(function () {
	'use strict';

	var DRAG_THRESHOLD = 5;

	function toArray(list) {
		return Array.prototype.slice.call(list);
	}

	
	function offsetWithin(scroller, el) {
		return el.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
	}

	function Slider(root) {
		this.root = root;
		this.track = root.querySelector('[data-ph-track]');
		this.slides = toArray(root.querySelectorAll('[data-ph-slide]'));
		this.thumbs = toArray(root.querySelectorAll('[data-ph-thumb]'));
		this.prev = root.querySelector('[data-ph-prev]');
		this.next = root.querySelector('[data-ph-next]');
		this.index = parseInt(root.getAttribute('data-active-index'), 10) || 0;

		if (!this.track || !this.slides.length) return;

		this.onThumbClick = this.onThumbClick.bind(this);
		this.onScroll = this.onScroll.bind(this);
		this.onKeydown = this.onKeydown.bind(this);
		this.onPointerDown = this.onPointerDown.bind(this);
		this.onPointerMove = this.onPointerMove.bind(this);
		this.onPointerUp = this.onPointerUp.bind(this);

		this.thumbs.forEach(function (thumb) {
			thumb.addEventListener('click', this.onThumbClick);
		}, this);

		if (this.prev) {
			this.prev.addEventListener(
				'click',
				function () {
					this.setActive(this.index - 1, true);
				}.bind(this)
			);
		}

		if (this.next) {
			this.next.addEventListener(
				'click',
				function () {
					this.setActive(this.index + 1, true);
				}.bind(this)
			);
		}

		this.track.addEventListener('scroll', this.onScroll, { passive: true });
		this.track.addEventListener('keydown', this.onKeydown);
		this.track.addEventListener('pointerdown', this.onPointerDown);

		this.setActive(this.index, false);
	}

	Slider.prototype.onThumbClick = function (event) {
		this.setActive(parseInt(event.currentTarget.getAttribute('data-ph-thumb'), 10), true);
	};

	Slider.prototype.onKeydown = function (event) {
		if (event.key === 'ArrowRight') {
			event.preventDefault();
			this.setActive(this.index + 1, true);
		} else if (event.key === 'ArrowLeft') {
			event.preventDefault();
			this.setActive(this.index - 1, true);
		}
	};

	
	Slider.prototype.onPointerDown = function (event) {
		if (event.pointerType !== 'mouse' || event.button !== 0) return;
		if (event.target.closest('a, video, model-viewer, iframe')) return;

		this.dragStartX = event.clientX;
		this.dragStartScroll = this.track.scrollLeft;
		this.dragging = false;

		window.addEventListener('pointermove', this.onPointerMove);
		window.addEventListener('pointerup', this.onPointerUp);
	};

	Slider.prototype.onPointerMove = function (event) {
		var delta = event.clientX - this.dragStartX;

		if (!this.dragging) {
			if (Math.abs(delta) < DRAG_THRESHOLD) return;
			this.dragging = true;
			this.track.style.scrollSnapType = 'none';
			this.track.classList.add('is-dragging');
		}

		event.preventDefault();
		this.track.scrollLeft = this.dragStartScroll - delta;
	};

	Slider.prototype.onPointerUp = function (event) {
		window.removeEventListener('pointermove', this.onPointerMove);
		window.removeEventListener('pointerup', this.onPointerUp);

		if (!this.dragging) return;

		this.dragging = false;
		this.track.style.scrollSnapType = '';
		this.track.classList.remove('is-dragging');

		var width = this.track.clientWidth;
		if (!width) return;

		var target = Math.round(this.track.scrollLeft / width);
		if (target === this.index && Math.abs(event.clientX - this.dragStartX) > width / 8) {
			target = event.clientX < this.dragStartX ? this.index + 1 : this.index - 1;
		}

		this.setActive(target, true);

		
		var swallow = function (e) {
			e.stopPropagation();
			e.preventDefault();
		};
		this.track.addEventListener('click', swallow, { capture: true, once: true });
		window.setTimeout(
			function () {
				this.track.removeEventListener('click', swallow, { capture: true });
			}.bind(this),
			0
		);
	};

	Slider.prototype.onScroll = function () {
		if (this.dragging) return;
		if (this.scrollTimer) window.clearTimeout(this.scrollTimer);
		this.scrollTimer = window.setTimeout(
			function () {
				var width = this.track.clientWidth;
				if (!width) return;
				var index = Math.round(this.track.scrollLeft / width);
				if (index !== this.index) this.markActive(index);
			}.bind(this),
			80
		);
	};

	Slider.prototype.markActive = function (index) {
		if (index < 0 || index >= this.slides.length) return;
		this.index = index;
		this.root.setAttribute('data-active-index', String(index));

		this.thumbs.forEach(function (thumb, i) {
			if (i === index) {
				thumb.setAttribute('aria-current', 'true');
			} else {
				thumb.removeAttribute('aria-current');
			}
		});

		this.revealThumb(index);
	};

	
	Slider.prototype.revealThumb = function (index) {
		var thumb = this.thumbs[index];
		if (!thumb) return;

		var strip = thumb.closest('[data-ph-thumbs]');
		if (!strip || strip.scrollWidth <= strip.clientWidth) return;

		var item = thumb.parentNode;
		var left = offsetWithin(strip, item);
		var right = left + item.getBoundingClientRect().width;

		if (left < strip.scrollLeft) {
			strip.scrollTo({ left: left - 12, behavior: 'smooth' });
		} else if (right > strip.scrollLeft + strip.clientWidth) {
			strip.scrollTo({ left: right - strip.clientWidth + 12, behavior: 'smooth' });
		}
	};

	Slider.prototype.setActive = function (index, animate) {
		if (index < 0) index = this.slides.length - 1;
		if (index >= this.slides.length) index = 0;

		this.markActive(index);

		var left = offsetWithin(this.track, this.slides[index]);
		var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		if (typeof this.track.scrollTo === 'function') {
			this.track.scrollTo({ left: left, behavior: animate && !reduced ? 'smooth' : 'auto' });
		} else {
			this.track.scrollLeft = left;
		}
	};

	function Lightbox(dialog) {
		this.dialog = dialog;
		this.inner = dialog.querySelector('[data-ph-gallery]');
		this.supported = typeof dialog.showModal === 'function';

		dialog.addEventListener('click', function (event) {
			if (event.target === dialog || event.target.closest('[data-ph-lightbox-close]')) {
				dialog.close();
			}
		});

		dialog.addEventListener('close', function () {
			document.documentElement.classList.remove('ph-lightbox-open');
		});

		dialog.addEventListener('keydown', function (event) {
			if (!this.inner || !this.inner.__phSlider) return;
			
			if (event.defaultPrevented) return;
			if (event.key === 'ArrowRight') {
				event.preventDefault();
				this.inner.__phSlider.setActive(this.inner.__phSlider.index + 1, true);
			} else if (event.key === 'ArrowLeft') {
				event.preventDefault();
				this.inner.__phSlider.setActive(this.inner.__phSlider.index - 1, true);
			}
		}.bind(this));
	}

	Lightbox.prototype.open = function (index) {
		if (!this.supported || !this.inner) return;

		document.documentElement.classList.add('ph-lightbox-open');
		this.dialog.showModal();

		
		if (this.inner.__phSlider) this.inner.__phSlider.setActive(index, false);

		
		var track = this.inner.querySelector('[data-ph-track]');
		if (track) track.focus({ preventScroll: true });
	};

	function initVariantSync(section) {
		var gallery = section.querySelector('[data-ph-gallery]');
		if (!gallery || !gallery.__phSlider) return;

		section.addEventListener('change', function (event) {
			var target = event.target;
			if (!target || target.name !== 'id') return;

			var source = target;
			if (target.tagName === 'SELECT') source = target.options[target.selectedIndex];

			var raw = source.getAttribute('data-l4pr-index');
			if (raw === null) return;

			var index = parseInt(raw, 10);
			if (isNaN(index) || index < 0) return;

			gallery.__phSlider.setActive(index, true);
		});
	}

	function init() {
		document.querySelectorAll('[data-ph-gallery]').forEach(function (root) {
			if (root.__phSlider) return;
			root.__phSlider = new Slider(root);
		});

		document.querySelectorAll('[data-ph-lightbox]').forEach(function (dialog) {
			if (dialog.__phLightbox) return;
			dialog.__phLightbox = new Lightbox(dialog);
		});

		document.querySelectorAll('.m6pr.product-hero').forEach(initVariantSync);
	}

	document.addEventListener('click', function (event) {
		var trigger = event.target.closest('[data-ph-zoom]');
		if (!trigger) return;

		var scope = trigger.closest('.l4pr-container') || document;
		var dialog = scope.querySelector('[data-ph-lightbox]') || document.querySelector('[data-ph-lightbox]');
		if (!dialog || !dialog.__phLightbox) return;

		event.preventDefault();
		dialog.__phLightbox.open(parseInt(trigger.getAttribute('data-ph-zoom'), 10) || 0);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', init);
})();
